export const CURRENT_USER_STORAGE_KEY = "justkasz.auth.current-user.v1";

export interface CachedCurrentUser {
  id: string;
  email: string | undefined;
  displayName: string;
}

interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

function browserStorage(): StorageLike | null {
  return typeof window === "undefined" ? null : window.localStorage;
}

export function readCachedCurrentUser(
  storage: StorageLike | null = browserStorage(),
): CachedCurrentUser | null {
  if (!storage) return null;
  try {
    const value = JSON.parse(storage.getItem(CURRENT_USER_STORAGE_KEY) ?? "null") as unknown;
    if (!value || typeof value !== "object") return null;
    const candidate = value as Record<string, unknown>;
    if (
      candidate.version !== 1 ||
      typeof candidate.id !== "string" ||
      !candidate.id.trim() ||
      typeof candidate.displayName !== "string" ||
      !candidate.displayName.trim() ||
      (candidate.email !== undefined && typeof candidate.email !== "string")
    ) {
      return null;
    }
    return {
      id: candidate.id,
      email: candidate.email as string | undefined,
      displayName: candidate.displayName,
    };
  } catch {
    return null;
  }
}

export function writeCachedCurrentUser(
  user: CachedCurrentUser,
  storage: StorageLike | null = browserStorage(),
): void {
  if (!storage) return;
  try {
    storage.setItem(CURRENT_USER_STORAGE_KEY, JSON.stringify({ version: 1, ...user }));
  } catch {
    // A storage quota or privacy setting must not block authentication.
  }
}

export function clearCachedCurrentUser(storage: StorageLike | null = browserStorage()): void {
  if (!storage) return;
  try {
    storage.removeItem(CURRENT_USER_STORAGE_KEY);
  } catch {
    // A storage privacy setting must not block sign-out.
  }
}
